import type { BffApiClient } from "@/app/api-client"

export const getAllCurrenciesQueryParams = (apiClient: BffApiClient) => {
  return {
    queryKey: ["currency", "all"],
    queryFn: async () => {
      const response = await apiClient.api.currencies.all.$get(undefined, {
        init: {
          next: {
            // Cache currencies response on next server for 1 minute
            revalidate: 60,
          },
        },
      })

      if (!response.ok) throw await response.json()

      return response.json()
    },
  }
}

type QueryFn = ReturnType<typeof getAllCurrenciesQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
